import React from "react";

import "babel-polyfill";

import ImageGridCell from "../../components/images/grid-cell";
import Macy from "macy";

class ImageGrid extends React.Component {
  async componentDidMount() {
    var loadScript = require('simple-load-script');
    await loadScript('/vendor/jquery/jquery-3.2.1.min.js', { inBody: true });
    loadScript('/vendor/fancybox/jquery.fancybox.min.js', { inBody: true });
    const imagesGrid = document.querySelector('.images-grid');

    if (imagesGrid) {
      Macy({
        container: '.images-grid',
        columns: 3,
        breakAt: {
          640: {
            columns: 2
          },
          374: {
            columns: 1
          }
        }
      });
    }
  }

  render() {
    const images = this.props.images;

    if (images && images.length > 0) {
      return (
        <ul className="images-grid">
          {images.map((image, idx) => (
            <ImageGridCell image={image.node} 
                           narratives={this.props.narratives}
                           artists={this.props.artists}
                           venues={this.props.venues}
                           exhibits={this.props.exhibits} 
                           key={idx} />
          ))}
        </ul>
      )
    }

    return null;
  }
}

export default ImageGrid;